/**
 * @module mapbs.components.reportpanel.service.reportservice
 */

import angular from 'angular';

const moduleReportservice = angular.module('mapbsReportserviceModule', []);

class ReportserviceController {
    /** @constructor
   * @struct
   * @param {angular.$injector} $injector Main injector.
   * @param {angular.$http} $http
   * @param {angular.$timeout} $timeout Angular timeout service.
   * @param {angular.$q} $q
   */
    constructor($injector, $http, $timeout, $q) {
    /** @type {string} */
        this.printBaseUrl = $injector.get('baseUrl');

        this.http = $http;
        this.timeout = $timeout;
        this.q = $q;

        /** @type {?angular.$q.Deferred} @private */
        this.requestCanceler_ = null;

        /** @type {string} @private */
        this.curRef_ = '';

        /** @type {string} */
        this.downloadurl = '';

        this.reportpromise = '';

        /** @type {string} */
        this.errormessage = '';

        /** @type {angular.$q.Promise} */
        this.statusTimeoutPromise_;
    }

    /**
   * Used to start the creation of a report
   *
   * @param {string} layout
   * @param {string} param
   * @return {angular.$q.Promise} Promise.
   */
    createReport(layout, param) {
        this.reportpromise = this.q.defer();
        this.requestCanceler_ = this.q.defer();

        const httpconfig = /** @type {angular.$http.Config} */ ({
            headers: {'Content-Type': 'text/xml; charset=UTF-8'},
            timeout: this.requestCanceler_.promise,
        });

        const spec = {};

        this.http
      .post(
          `${this.printBaseUrl}bsreport.pdf/${layout}/${param}`,
          spec,
          httpconfig
      )
      .then((resp) => {
          const mfResp = /** @type {MapFishPrintReportResponse} */ (resp.data);
          this.curRef_ = mfResp.ref;
          this.getPrintstatus();
      });
        return this.reportpromise.promise;
    }

    /**
   * polls server to get status update for current report generation
   * @private
   */
    getPrintstatus() {
        if (this.curRef_ === 'undefined') {
            return;
        }

        this.requestCanceler_ = this.q.defer();

        const httpconfig = /** @type {angular.$http.Config} */ ({
            timeout: this.requestCanceler_.promise,
        });

        this.http
      .get(`${this.printBaseUrl}bsreport/status/${this.curRef_}`, httpconfig)
      .then(
          this.handleReportstatusSuccess.bind(this),
          this.handleReportstatusError.bind(this)
      );
    }

    /**
   * handles successfull status update
   * @private
   */
    handleReportstatusSuccess(resp) {
        if (resp.data.done) {
            if (resp.data.status !== 'error') {
                this.downloadurl = `${this.printBaseUrl}bsreport/get/${this.curRef_}`;
                this.reportpromise.resolve(this.downloadurl);
            } else {
                this.errormessage = 'Fehler beim Erstellen des Reportes'; //TODO translate
                this.reportpromise.reject(this.errormessage);
            }

            this.requestCanceler_ = null;
            this.statusTimeoutPromise_ = null;
            this.curRef_ = '';
        } else {
            this.statusTimeoutPromise_ = this.timeout(
                () => {
                    this.getPrintstatus();
                },
                1000,
                false
            );
        }
    }

    /**
   * handles error while status update
   * @private
   */
    handleReportstatusError() {
        this.errormessage = 'Fehler beim Erstellen des Dokumentes';
        this.reportpromise.reject(this.errormessage);
    }

    /**
   * stops the creation of the report
   */
    cancelReport() {
        if (this.requestCanceler_ !== null) {
            this.requestCanceler_.resolve();
        }

        if (this.statusTimeoutPromise_ !== null) {
            this.timeout.cancel(this.statusTimeoutPromise_);
        }

        if (this.curRef_.length > 0) {
            try {
                this.deletePrint();
            } catch (err) {
                console.log('Error deleting'); // eslint-disable-line no-console
            }
        }

        this.curRef_ = '';
    }

    /**
   * stops the creation of the report on server
   * @private
   */
    deletePrint() {
        const deleteurl = `${this.printBaseUrl}bsreport/cancel/${this.curRef_}`; //TODO url param
        const httpconfig = /** @type {angular.$http.Config} */ ({
            timeout: this.requestCanceler_.promise,
        });

        this.http.delete(deleteurl, httpconfig).then(
            (response) => {
                console.log(response);
            } // eslint-disable-line no-console
        );
    }
}

moduleReportservice.service('mapbsReportservice', ReportserviceController);

export default moduleReportservice;
